import { Switch, Route } from 'react-router-dom';
import { LoggedOutRoute, LoggedInRouter, TokenRoute } from './';
import {
	Invite,
	Login,
	ErrorPage,
	InvalidToken,
	DashboardWrapper,
	EmailVerify,
	FamilyConnectRedirect,
	LifebookVideo,
} from 'components';
import ReadOnlyContainer from '../components/UtilityComponents/PageLayout/components/ReadOnlyContainer';
import ConnectRouter from './ConnectRouter';

// {sandbox.}video.ella.care only serves the public page LifeBook PDF QR codes open.
const isVideoHost = /^(sandbox\.)?video\.ella\.care$/.test(window.location.hostname);

export function AppRouter({ loading }) {
	if (isVideoHost) return <Route path='/:id?' component={LifebookVideo} />;
	return (
		<Switch>
			<TokenRoute path='/connect'>
				<ConnectRouter loading={loading} />
			</TokenRoute>
			<LoggedOutRoute path='/familyconnections/'>
				<FamilyConnectRedirect />
			</LoggedOutRoute>
			<TokenRoute path='/auditoraccess/:feedType?/:childId?'>
				<ReadOnlyContainer baseRoute='auditoraccess' />
			</TokenRoute>
			<TokenRoute path='/readonly/:feedType?/:childId?'>
				<ReadOnlyContainer baseRoute='readonly' />
			</TokenRoute>
			<Route path='/invalidtoken/' component={InvalidToken} />
			<LoggedOutRoute path='/invite/:inviteType?' component={Invite} />
			<LoggedOutRoute path='/ownership/' component={Login} />
			<LoggedOutRoute path='/login/' component={Login} />
			<LoggedOutRoute exact path='/reset/' component={Login} />
			<Route key='verify' path='/verify' component={EmailVerify} />
			<Route path='/lifebook/video' component={LifebookVideo} />
			<Route path='/error/' component={ErrorPage} />
			<Route path='/'>
				<DashboardWrapper loading={loading}>
					<LoggedInRouter />
				</DashboardWrapper>
			</Route>
		</Switch>
	);
}

export default AppRouter;
